// One normaliser for a booking-import response, used by BOTH the in-dialog summary panel and the
// snackbar that reports the same upload. They used to derive `has_warning` from the same mutation,
// which coupled the snackbar to whether the panel still existed: closing the dialog mid-upload
// cleared the panel, and the snackbar then had nothing to read.
//
// Returns null for a missing payload, so a caller can always ask "did this upload warn?" without
// checking the shape first.
// A CS Center the sheet left empty is still an unrecognised value, and it is the one an operator
// most needs named — but it renders as nothing at all. It is displayed as "(blank)" HERE so the
// panel and the snackbar cannot describe the same upload differently; the panel used to do this
// mapping itself, which is why a closed dialog left "unrecognised CS Center:" with nothing after it.
const displayCsCenter = value => (String(value === null || value === undefined ? '' : value).trim() === '' ? '(blank)' : value)

export function normalizeImportSummary(payload) {
  if (!payload) return null
  const fallback_rows = Number(payload.fallback_rows || 0)
  const unknown_cs_centers = (Array.isArray(payload.unknown_cs_centers) ? payload.unknown_cs_centers : []).map(displayCsCenter)
  return {
    ...payload,
    fallback_rows,
    unknown_cs_centers,
    // Rows that fell through to the default profile, or a CS Center nobody has a profile for,
    // are a partial success: the import worked but somebody has to look at those rows.
    has_warning: fallback_rows > 0 || unknown_cs_centers.length > 0
  }
}

// The operator-facing sentence for one upload, built from the response alone so it stays true
// whatever the dialog is doing.
export function importWarningDetails(summary) {
  if (!summary || !summary.has_warning) return []
  const details = []
  if (summary.fallback_rows) details.push(`${summary.fallback_rows} row(s) routed to the default profile`)
  if (summary.unknown_cs_centers.length) details.push(`unrecognised CS Center: ${summary.unknown_cs_centers.join(', ')}`)
  return details
}
